// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VAlert,
  VIcon,
  VGrid,
  VToolbar,
  transitions
} from 'vuetify'
import '../node_modules/vuetify/src/stylus/app.styl'

import App from './App'
import router from './router'

var config = {
  apiKey: "AIzaSyBgir6qEVxMI6-h32iKTi1NB4KzXB8cuKs",
  authDomain: "redhat-js-58d31.firebaseapp.com",
  projectId: "redhat-js-58d31",
  databaseURL: "https://redhat-js-58d31.firebaseio.com",
  storageBucket: "redhat-js-58d31.appspot.com",
  messagingSenderId: "356376760868"
};
firebase.initializeApp(config);

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VAlert,
    VIcon,
    VGrid,
    VToolbar,
    transitions
  }
})

Vue.config.productionTip = false

var vm = new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
})


// WEBPACK FOOTER //
// ./src/main.js